import { http } from './client';
import type { GoogleChatConfigPatch, GoogleChatConfigView } from './types';

export const googleChatApi = {
  async get(botId: string): Promise<GoogleChatConfigView> {
    const res = await http.get<GoogleChatConfigView>(
      `/v1/org/bots/${encodeURIComponent(botId)}/google-chat`,
    );
    return res.data;
  },
  async update(botId: string, patch: GoogleChatConfigPatch): Promise<GoogleChatConfigView> {
    const res = await http.put<GoogleChatConfigView>(
      `/v1/org/bots/${encodeURIComponent(botId)}/google-chat`,
      patch,
    );
    return res.data;
  },
};
